import React from 'react';

export default function DashboardStatsRow() {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-4 mb-6">

      {/* Profile Completion */}
      <div className="bg-black p-4 rounded shadow">
        <h3 className="text-sm font-semibold mb-1">👤 Profile Completion</h3>
        <div className="w-full bg-gray-200 h-2 rounded">
          <div className="bg-blue-500 h-2 rounded" style={{ width: '70%' }}></div>
        </div>
        <p className="text-xs text-gray-500 mt-1">70% completed</p>
      </div>

      {/* Wallet Balance */}
      <div className="bg-black p-4 rounded shadow">
        <h3 className="text-sm font-semibold mb-1">💰 Wallet Balance</h3>
        <p className="text-xl font-bold text-green-600">$1,240.50</p>
        <p className="text-xs text-gray-500 mt-1">Updated 1h ago</p>
      </div>

      {/* Karma Score */}
      <div className="bg-black p-4 rounded shadow">
        <h3 className="text-sm font-semibold mb-1">📈 Trust Score</h3>
        <p className="text-xl font-bold text-indigo-500">84 / 100</p>
        <p className="text-xs text-gray-500 mt-1">Based on community feedback</p>
      </div>

      {/* Badges */}
      <div className="bg-black p-4 rounded shadow">
        <h3 className="text-sm font-semibold mb-1">🏅 Badges</h3>
        <p className="text-xl font-bold text-yellow-500">Pro Mentor 🥇</p>
        <p className="text-xs text-gray-500 mt-1">Last awarded: 2 days ago</p>
      </div>

    </div>
  );
}
